// Core packages
import { FormGroup } from "@angular/forms";

// Third party packages

// Custom packages

/**
 * Creates a forrmly field group by docuemnt type.title
 * Es. to doc type = AA1 get A4Schema formly field group
 *
 * @since 1.0.0
 */
export default class DocumentTypeStructure {
  form: FormGroup = new FormGroup({});

  private orderContracts = [
    "AG1",
    "IA16",
    "ND3",
    "NA3",
    "ND1",
    "NB3",
    "HA6",
    "HA7",
    "HA8",
    "AB6",
    "AG2",
    "AD2",
    "HA12",
    "HA64",
    "QC11",
    "QB11",
    "NE1",
    "LC1",
    "LB1",
    "LA5",
    "LA8",
    "LA40",
    "LG12",
    "LO38",
    "LH17",
    "LI8",
    "LL6",
    "MA8",
    "MA10",
    "MB8",
    "MB10",
    "IA6",
    "IB9",
    "IA10",
    "IB13",
    "IA13",
    "IB15",
    "IB6",
    "NB5",
    "QA1",
    "QB6",
    "QC7",
    "QD5",
    "RE4",
    "QE5",
    "QF5",
    "LM5",
    "AB2",
    "OE6",
    "LG4",
    "LG9",
    "RB5",
    "RI3",
    "ID7",
    "NC3",
    "HA44",
    "LI5",
    "IC5",
    "IE7",
    "HA48",
    "AB11",
    "OC5",
    "OD5",
    "OF5",
    "OE3",
    "TA8",
    "TA12",
    "OA5",
    "OB5",
    "LF5",
    "RL19",
    "RF4",
    "HA61",
    "RM5"
    ];
 

  dataType = {
    A3mSchema: {
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    A4PlusSchema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    A4Schema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    A5Schema: {
      nomeFornitore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "suppliersName",
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    A5mSchema: {
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataStipulaContratto",
      },
      dataPrimaScadenza: {
        type: "DateNotAvailable",
        required: true,
        label: "dataPrimaScadenza",
      },
      tempoDiPreavviso: {
        type: "Select",
        required: true,
        options: [
          {
            value: "0",
            label: "properties.structures.types.disdetta0",
          },
          {
            value: "30",
            label: "properties.structures.types.disdetta30",
          },
          {
            value: "60",
            label: "properties.structures.types.disdetta60",
          },
          {
            value: "90",
            label: "properties.structures.types.disdetta90",
          },
          {
            value: "120",
            label: "properties.structures.types.disdetta120",
          },
          {
            value: "150",
            label: "properties.structures.types.disdetta150",
          },
          {
            value: "180",
            label: "properties.structures.types.disdetta180",
          },
          {
            value: "365",
            label: "properties.structures.types.disdetta365",
          },
          {
            value: "730",
            label: "properties.structures.types.disdetta730",
          },
          {
            value: "15a",
            label: "properties.structures.types.disdetta15a",
          },
          {
            value: "20a",
            label: "properties.structures.types.disdetta20a",
          },
          {
            value: "25a",
            label: "properties.structures.types.disdetta25a",
          },
        ],
      },
      dataSecondaScadenza: {
        type: "Date",
        required: true,
        label: "dataSecondaScadenza",
      },
      tempoPreavvisoDisdetta: {
        type: "Select",
        required: true,
        options: [
          {
            value: "0",
            label: "properties.structures.types.disdetta0",
          },
          {
            value: "30",
            label: "properties.structures.types.disdetta30",
          },
          {
            value: "60",
            label: "properties.structures.types.disdetta60",
          },
          {
            value: "90",
            label: "properties.structures.types.disdetta90",
          },
          {
            value: "120",
            label: "properties.structures.types.disdetta120",
          },
          {
            value: "150",
            label: "properties.structures.types.disdetta150",
          },
          {
            value: "180",
            label: "properties.structures.types.disdetta180",
          },
          {
            value: "365",
            label: "properties.structures.types.disdetta365",
          },
          {
            value: "730",
            label: "properties.structures.types.disdetta730",
          },
          {
            value: "15a",
            label: "properties.structures.types.disdetta15a",
          },
          {
            value: "20a",
            label: "properties.structures.types.disdetta20a",
          },
          {
            value: "25a",
            label: "properties.structures.types.disdetta25a",
          },
        ],
      },
      durataAPartireDallaSecondaScadenza: {
        type: "Select",
        required: true,
        options: [
          {
            value: "3m",
            label: "properties.structures.types.mesi3",
          },
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "9m",
            label: "properties.structures.types.mesi9",
          },
          {
            value: "0a",
            label: "properties.structures.types.anni0",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
          {
            value: "15a",
            label: "properties.structures.types.disdetta15a",
          },
          {
            value: "20a",
            label: "properties.structures.types.disdetta20a",
          },
          {
            value: "25a",
            label: "properties.structures.types.disdetta25a",
          },
        ],
        expressionProperties: {
          "templateOptions.onChange": (
            model: any,
            formState: any,
            field: any
          ): void => {
            let ret = "";
            if (
              typeof model.durataAPartireDallaSecondaScadenza !== "undefined" &&
              model.durataAPartireDallaSecondaScadenza !== "" &&
              model.durataAPartireDallaSecondaScadenza !== "0a" &&
              model.tipoDiRinnovo !== "Rinnovo automatico"
            ) {
              ret = "Rinnovo automatico";
              field.form.controls["tipoDiRinnovo"].setValue(ret);
            } else if (
              typeof model.durataAPartireDallaSecondaScadenza !== "undefined" &&
              model.durataAPartireDallaSecondaScadenza === "0a" &&
              model.tipoDiRinnovo !== "Senza rinnovo automatico"
            ) {
              ret = "Senza rinnovo automatico";
              field.form.controls["tipoDiRinnovo"].setValue(ret);
            } else if (
              typeof model.durataAPartireDallaSecondaScadenza !== "undefined" &&
              model.durataAPartireDallaSecondaScadenza === "" &&
              model.tipoDiRinnovo !== ""
            ) {
              ret = "";
              field.form.controls["tipoDiRinnovo"].setValue(ret);
            }
          },
        },
      },
      tipoDiRinnovo: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        readonly: true,
      },
      importo: {
        type: "Number",
        min: 0,
        max: 99999999,
        required: false,
      },
    },
    A7Schema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "data",
      },
      pagamento: {
        type: "Select",
        required: true,
        options: [
          {
            value: "unicaSoluzione",
            label: "properties.detail.documentArchive.fields.pagamentoUnicaSoluzione",
          },
          {
            value: "aRate",
            label: "properties.detail.documentArchive.fields.pagamentoARate",
          },
        ],
      },
    },
    A8Schema: {
      rilasciatoFirmatoDa: {
        type: "String",
        minlenght: 2,
        maxlenght: 500,
        required: true,
      },
      numeroProtocollo: {
        type: "String",
        minlenght: 2,
        maxlenght: 500,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    A8PlusSchema: {
      rilasciatoFirmatoDa: {
        type: "String",
        minlenght: 2,
        maxlenght: 500,
        required: true,
      },
      numeroProtocollo: {
        type: "String",
        minlenght: 2,
        maxlenght: 500,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    A9Schema: {
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
      rilasciatoFirmatoDa: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      numeroProtocollo: {
        type: "String",
        minlenght: 2,
        maxlenght: 500,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    ASchema: {
      nomeSocietaEroganteInServizio: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataStipulaContratto",
      },
      importo: {
        type: "Number",
        min: 0,
        max: 99999999,
        required: false,
      },
    },
    B2Schema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    B3Schema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
    },
    B5Schema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 0,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      prescrizioni: {
        type: "Select",
        enum: ["assenti", "presenti"],
        maxlenght: 50,
        required: true,
        defaultValue: "assenti",
        options: [
          {
            value: "assenti",
            label: "properties.structures.types.assenti",
          },
          {
            value: "presenti",
            label: "properties.structures.types.presenti",
          },
        ],
      },
    },
    B6Schema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDellaVerifica",
      },
      durataDocumento: {
        type: "Select",
        required: true,
        options: [
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
        ],
      },
    },
    B6StarSchema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDellaVerifica",
      },
      durataDocumento: {
        type: "Select",
        required: true,
        options: [
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
        ],
      },
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
    },
    BBMinusSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "String", // "Date",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    BBPlusSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "String", // "Date",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    BBSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "String", // "Date",
        required: true,
        label: "dataEmissioneDocumento",
      },
    },
    BBSlashSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "String", // "Date",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeFornitore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "suppliersName",
      },
    },
    BBStarSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "String", // "Date",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
    },
    BMinusSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    BPlusSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    BSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    BSlashSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeFornitore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "suppliersName",
      },
    },
    BStarSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
    },
    BXSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDellaVerifica",
      },
      durataDocumento: {
        type: "Select",
        required: true,
        options: [
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
          {
            value: "15a",
            label: "properties.structures.types.anni15",
          },
          {
            value: "30a",
            label: "properties.structures.types.anni30",
          },
        ],
      },
    },
    DSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataStipula",
      },
      dataPrimaScadenza: {
        type: "Date",
        required: true,
        label: "dataPrimaScadenza",
      },
      durataAPartireDallaPrimaScadenza: {
        type: "Select",
        required: true,
        options: [
          {
            value: "3m",
            label: "properties.structures.types.mesi3",
          },
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "9m",
            label: "properties.structures.types.mesi9",
          },
          {
            value: "0a",
            label: "properties.structures.types.anni0",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
          {
            value: "15a",
            label: "properties.structures.types.anni15",
          },
          {
            value: "20a",
            label: "properties.structures.types.anni20",
          },
          {
            value: "25a",
            label: "properties.structures.types.anni25",
          },
        ],
        expressionProperties: {
          "templateOptions.onChange": (
            model: any,
            formState: any,
            field: any
          ): void => {
            if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza !== "" &&
              model.durataAPartireDallaPrimaScadenza !== "0a" &&
              model.tipoDiRinnovo !== "Rinnovo automatico"
            ) {
              field.form.controls["tipoDiRinnovo"].setValue(
                "Rinnovo automatico"
              );
            } else if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza === "0a" &&
              model.tipoDiRinnovo !== "Senza rinnovo automatico"
            ) {
              field.form.controls["tipoDiRinnovo"].setValue(
                "Senza rinnovo automatico"
              );
            } else if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza === "" &&
              model.tipoDiRinnovo !== ""
            ) {
              field.form.controls["tipoDiRinnovo"].setValue("");
            }
          },
        },
      },
      tipoDiRinnovo: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        readonly: true,
      },
      tempoPreavvisoDisdetta: {
        type: "Select",
        required: true,
        options: [
          {
            value: "0",
            label: "properties.structures.types.disdetta0",
          },
          {
            value: "30",
            label: "properties.structures.types.disdetta30",
          },
          {
            value: "60",
            label: "properties.structures.types.disdetta60",
          },
          {
            value: "90",
            label: "properties.structures.types.disdetta90",
          },
          {
            value: "120",
            label: "properties.structures.types.disdetta120",
          },
          {
            value: "150",
            label: "properties.structures.types.disdetta150",
          },
          {
            value: "180",
            label: "properties.structures.types.disdetta180",
          },
          {
            value: "365",
            label: "properties.structures.types.disdetta365",
          },
          {
            value: "730",
            label: "properties.structures.types.disdetta730",
          },
          {
            value: "5475",
            label: "properties.structures.types.disdetta15a",
          },
          {
            value: "7300",
            label: "properties.structures.types.disdetta20a",
          },
          {
            value: "9125",
            label: "properties.structures.types.disdetta25a",
          },
        ],
      },
      periodicitaInterventi: {
        type: "Select",
        required: true,
        options: [
          {
            value: "1m",
            label: "properties.structures.types.mesi1",
          },
          {
            value: "2m",
            label: "properties.structures.types.mesi2",
          },
          {
            value: "3m",
            label: "properties.structures.types.mesi3",
          },
          {
            value: "4m",
            label: "properties.structures.types.mesi4",
          },
          {
            value: "5m",
            label: "properties.structures.types.mesi5",
          },
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
        ],
      },
      importo: {
        type: "Number",
        min: 0,
        max: 99999999,
        required: false,
      },
    },
    E1Schema: {
      tipologiaIntervento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
    },
    F1Schema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: false,
        label: "dataDocumento",
      },
      meseDiRiferimento: {
        type: "String",
        minlenght: 2,
        maxlenght: 20,
        required: true,
      },
    },
    F2Schema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataStipula",
      },
      dataPrimaScadenza: {
        type: "Date",
        required: true,
        label: "dataPrimaScadenza",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
      durataAPartireDallaPrimaScadenza: {
        type: "Select",
        required: true,
        options: [
          {
            value: "3m",
            label: "properties.structures.types.mesi3",
          },
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "9m",
            label: "properties.structures.types.mesi9",
          },
          {
            value: "0a",
            label: "properties.structures.types.anni0",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
          {
            value: "15a",
            label: "properties.structures.types.anni15",
          },
          {
            value: "20a",
            label: "properties.structures.types.anni20",
          },
          {
            value: "25a",
            label: "properties.structures.types.anni25",
          },
        ],
        expressionProperties: {
          "templateOptions.onChange": (
            model: any,
            formState: any,
            field: any
          ): void => {
            if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza !== "" &&
              model.durataAPartireDallaPrimaScadenza !== "0a" &&
              model.tipoDiRinnovo !== "Rinnovo automatico"
            ) {
              field.form.controls["tipoDiRinnovo"].setValue(
                "Rinnovo automatico"
              );
            } else if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza === "0a" &&
              model.tipoDiRinnovo !== "Senza rinnovo automatico"
            ) {
              field.form.controls["tipoDiRinnovo"].setValue(
                "Senza rinnovo automatico"
              );
            } else if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza === "" &&
              model.tipoDiRinnovo !== ""
            ) {
              field.form.controls["tipoDiRinnovo"].setValue("");
            }
          },
        },
      },
      tipoDiRinnovo: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        readonly: true,
      },
      tempoPreavvisoDisdetta: {
        type: "Select",
        required: true,
        options: [
          {
            value: "0",
            label: "properties.structures.types.disdetta0",
          },
          {
            value: "30",
            label: "properties.structures.types.disdetta30",
          },
          {
            value: "60",
            label: "properties.structures.types.disdetta60",
          },
          {
            value: "90",
            label: "properties.structures.types.disdetta90",
          },
          {
            value: "120",
            label: "properties.structures.types.disdetta120",
          },
          {
            value: "150",
            label: "properties.structures.types.disdetta150",
          },
          {
            value: "180",
            label: "properties.structures.types.disdetta180",
          },
          {
            value: "365",
            label: "properties.structures.types.disdetta365",
          },
          {
            value: "730",
            label: "properties.structures.types.disdetta730",
          },
          {
            value: "15a",
            label: "properties.structures.types.disdetta15a",
          },
          {
            value: "20a",
            label: "properties.structures.types.disdetta20a",
          },
          {
            value: "25a",
            label: "properties.structures.types.disdetta25a",
          },
        ],
      },
      importo: {
        type: "Number",
        min: 0,
        max: 99999999,
        required: false,
      },
    },
    FSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataStipula",
      },
      dataPrimaScadenza: {
        type: "Date",
        required: true,
        label: "dataPrimaScadenza",
      },
      durataAPartireDallaPrimaScadenza: {
        type: "Select",
        required: true,
        options: [
          {
            value: "3m",
            label: "properties.structures.types.mesi3",
          },
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "9m",
            label: "properties.structures.types.mesi9",
          },
          {
            value: "0a",
            label: "properties.structures.types.anni0",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
          {
            value: "15a",
            label: "properties.structures.types.anni15",
          },
          {
            value: "20a",
            label: "properties.structures.types.anni20",
          },
          {
            value: "25a",
            label: "properties.structures.types.anni25",
          },
        ],
        expressionProperties: {
          "templateOptions.onChange": (
            model: any,
            formState: any,
            field: any
          ): void => {
            let ret = "";
            if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza !== "" &&
              model.durataAPartireDallaPrimaScadenza !== "0a" &&
              model.tipoDiRinnovo !== "Rinnovo automatico"
            ) {
              ret = "Rinnovo automatico";
              field.form.controls["tipoDiRinnovo"].setValue(ret);
            } else if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza === "0a" &&
              model.tipoDiRinnovo !== "Senza rinnovo automatico"
            ) {
              ret = "Senza rinnovo automatico";
              field.form.controls["tipoDiRinnovo"].setValue(ret);
            } else if (
              typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
              model.durataAPartireDallaPrimaScadenza === "" &&
              model.tipoDiRinnovo !== ""
            ) {
              ret = "";
              field.form.controls["tipoDiRinnovo"].setValue(ret);
            }
          },
        },
      },
      tipoDiRinnovo: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        readonly: true,
      },
      tempoPreavvisoDisdetta: {
        type: "Select",
        required: true,
        options: [
          {
            value: "0",
            label: "properties.structures.types.disdetta0",
          },
          {
            value: "30",
            label: "properties.structures.types.disdetta30",
          },
          {
            value: "60",
            label: "properties.structures.types.disdetta60",
          },
          {
            value: "90",
            label: "properties.structures.types.disdetta90",
          },
          {
            value: "120",
            label: "properties.structures.types.disdetta120",
          },
          {
            value: "150",
            label: "properties.structures.types.disdetta150",
          },
          {
            value: "180",
            label: "properties.structures.types.disdetta180",
          },
          {
            value: "365",
            label: "properties.structures.types.disdetta365",
          },
          {
            value: "730",
            label: "properties.structures.types.disdetta730",
          },
          {
            value: "15a",
            label: "properties.structures.types.disdetta15a",
          },
          {
            value: "20a",
            label: "properties.structures.types.disdetta20a",
          },
          {
            value: "25a",
            label: "properties.structures.types.disdetta25a",
          },
        ],
      },
      importo: {
        type: "Number",
        min: 0,
        max: 99999999,
        required: false,
      },
    },
    G1Schema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataRilascioDocumento",
      },
      tipoDurataPermessoDiSoggiorno: {
        type: "Select",
        enum: ["limitato", "illimitato"],
        maxlenght: 50,
        required: true,
        defaultValue: "limitato",
        options: [
          {
            value: "limitato",
            label: "properties.structures.types.limitato",
          },
          {
            value: "illimitato",
            label: "properties.structures.types.illimitato",
          },
        ],
      },
      //(tendina: limitato/illimitato)
      //(se limitato: data scadenza)
      dataScadenza: {
        type: "Date",
        expressionProperties: {
          "templateOptions.required":
            "model.tipoDurataPermessoDiSoggiorno ==='limitato'",
        },
        label: "dataScadenza",
      },
    },
    GMinusSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    GPlusSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    GSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
    },
    GSlashSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeFornitore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "suppliersName",
      },
    },
    GStarSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
    },
    H1Schema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: false,
        label: "dataDocumento",
      },
      annoDiRiferimento: {
        type: "Number",
        required: true,
      },
      annoDiArchiviazione: {
        type: "SelectNew",
        required: true,
        options: "yearsOfStorage",
      },
    },
    I1Schema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataRichiesta",
      },
      dataScadenzaAstensione: {
        type: "Date",
        required: true,
        label: "dataScadenzaAstensione",
      },
    },
    L2Schema: {
      daNome: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      aNnome: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    LPlusSchema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: false,
        label: "dataDocumento",
      },
      ragioneSocialeCostruttore: {
        type: "String",
        minlenght: 2,
        maxlenght: 100,
        required: true,
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    LSchema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: false,
        label: "dataDocumento",
      },
      ragioneSocialeCostruttore: {
        type: "String",
        minlenght: 2,
        maxlenght: 100,
        required: true,
      },
    },
    RSchema: {
      riferimentoComuneASL: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      nomeIspettore: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
    },
    SSchema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: false,
        label: "dataDocumento",
      },
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      nomeFirmatarioAutorizzatoDellaDittaInstallatrice: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      annoDiInstallazioneDellImpianto: {
        type: "Number",
        required: true,
      },
    },
    TSchema: {
      nomeAmministratoreDelCondominio: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      nomeFornitoreCombustibile: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
    },
    TXSchema: {
      nomeAmministratoreDelCondominio: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
      durataDocumento: {
        type: "Select",
        required: true,
        options: [
          {
            value: "6m",
            label: "properties.structures.types.mesi6",
          },
          {
            value: "1a",
            label: "properties.structures.types.anni1",
          },
          {
            value: "2a",
            label: "properties.structures.types.anni2",
          },
          {
            value: "3a",
            label: "properties.structures.types.anni3",
          },
          {
            value: "4a",
            label: "properties.structures.types.anni4",
          },
          {
            value: "5a",
            label: "properties.structures.types.anni5",
          },
          {
            value: "6a",
            label: "properties.structures.types.anni6",
          },
          {
            value: "7a",
            label: "properties.structures.types.anni7",
          },
          {
            value: "8a",
            label: "properties.structures.types.anni8",
          },
          {
            value: "9a",
            label: "properties.structures.types.anni9",
          },
          {
            value: "10a",
            label: "properties.structures.types.anni10",
          },
        ],
      },
    },
    WSchema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: false,
        label: "dataDocumento",
      },
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      periodoDiRiferimentoDa: {
        type: "Date",
        required: true,
        label: "periodoDiRiferimentoDa",
      },
      periodoDiRiferimentoA: {
        type: "Date",
        required: true,
        label: "periodoDiRiferimentoA",
      },
    },
    WPlusSchema: {
      dataDocumento: {
        type: "DateNotAvailable",
        required: false,
        label: "dataDocumento",
      },
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      periodoDiRiferimentoDa: {
        type: "Date",
        required: true,
        label: "periodoDiRiferimentoDa",
      },
      periodoDiRiferimentoA: {
        type: "Date",
        required: true,
        label: "periodoDiRiferimentoA",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    XSchema: {
      nomeIdentificativoDellaReteDiTeleriscaldamento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataStipulaContratto",
      },
    },
    XX1MinusSchema: {
      nomeDiRiferimento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    XX1PlusSchema: {
      nomeDiRiferimento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    XX1Schema: {
      nomeDiRiferimento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    XX1SlashSchema: {
      nomeDiRiferimento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeFornitore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "suppliersName",
      },
    },
    XX1StarSchema: {
      nomeDiRiferimento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeConduttore: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "conductorName",
      },
    },
    YSchema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      nomeStudioProgettazione: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataEmissioneDocumento",
      },
    },
    Z1Schema: {
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
    },
    Z1PlusSchema: {
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    Z3Schema: {
      ragioneSocialeFornitore: {
        type: "Hidden",
        defaultValue: '',
      },
      ragioneSocialeFornitoreId: {
        type: "Autocomplete-Supplier",
        bindLabel: "companyName",
        bindValue: "_id",
        multiple: false,
        search: "suppliersService",
        required: true,
      },
      aFirmaDi: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
    Z4Schema: {
      titoloDocumento: {
        type: "String",
        minlenght: 2,
        maxlenght: 50,
        required: true,
      },
      dataDocumento: {
        type: "DateNotAvailable",
        required: true,
        label: "dataDocumento",
      },
      nomeArchiviazioneIntervento: {
        type: "SelectNew",
        minlenght: 2,
        maxlenght: 50,
        required: true,
        options: "nameInterventionArchiving",
      },
    },
  };

  

  /**
   * Get formly field group by doc type
   *
   * @since 1.0.0
   */
  getFormlyFields2(schemaType: string, disabled: boolean): any {
    const aryFields = [];
    if (schemaType) {
      const structureType = this.dataType[schemaType];
      for (const prop in structureType) {
        if (
          structureType[prop].type === "Autocomplete" ||
          structureType[prop].type === "Autocomplete-Supplier"
        ) {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            type: structureType[prop].type.toLowerCase(),
            key: `${prop}`,
            expressionProperties: structureType[prop].expressionProperties
              ? structureType[prop].expressionProperties
              : "",
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              customLabel: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              placeholder: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              required: structureType[prop].required,
              disabled: disabled,
              bindLabel: structureType[prop].bindLabel,
              bindValue: structureType[prop].bindValue,
              multiple: structureType[prop].multiple,
              search$: structureType[prop].search,
              addTag: (term: string) => {
                return term.replace(/\./gi, "").toUpperCase();
              },
              addTagText: "common.words.addTag",
            },
          });
        }
        if (structureType[prop].type === "String") {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "input",
            key: `${prop}`,
            expressionProperties: structureType[prop].expressionProperties
              ? structureType[prop].expressionProperties
              : "",
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              label: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              placeholder: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              required: structureType[prop].required,
              minLength: structureType[prop].minLength,
              maxLength: structureType[prop].maxLength,
              disabled: disabled,
            },
          });
        }
        if (structureType[prop].type === "Textarea") {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "textarea",
            key: `${prop}`,
            expressionProperties: structureType[prop].expressionProperties
              ? structureType[prop].expressionProperties
              : "",
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              label: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              placeholder: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              required: structureType[prop].required,
              minLength: structureType[prop].minLength,
              maxLength: structureType[prop].maxLength,
              disabled: disabled,
              rows: structureType[prop].rows,
            },
          });
        }
        if (structureType[prop].type === "Date") {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "datepicker",
            key: `${prop}`,
            expressionProperties: structureType[prop].expressionProperties
              ? structureType[prop].expressionProperties
              : "",
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              label: `properties.detail.documentArchive.fields.${structureType[prop].label}`,
              placeholder: `properties.detail.documentArchive.fields.${prop}`,
              required: structureType[prop].required,
              disabled: disabled,
            },
          });
        }
        if (structureType[prop].type === "DateNotAvailable") {
          aryFields.push({
            className: "col-8 col-md-8 col-xl-8",
            type: "datepicker",
            key: `${prop}`,
            expressionProperties: {
              "templateOptions.required":(model: any) => {
                const currentValue = model[`${prop}chkNA`];
                return !currentValue;
              },
              "templateOptions.disabled":(model: any) => {
                const currentValue = model[`${prop}chkNA`];
                return currentValue;
              }
            },
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              label: `properties.detail.documentArchive.fields.${structureType[prop].label}`,
              placeholder: `properties.detail.documentArchive.fields.${prop}`,
              required: structureType[prop].required,
            },
          });
          aryFields.push({
            className: "col-4 col-md-4 col-xl-4",
            type: "checkbox",
            key: `${prop}chkNA`,
            defaultValue: false,
            templateOptions: {
              readonly: false,
              label: `properties.detail.documentArchive.notAvailable`,
              placeholder: `properties.detail.documentArchive.notAvailable`,
              required: false,
              disabled: false,
            },
          });
        }
        if (structureType[prop].type === "Number") {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "input",
            key: `${prop}`,
            hide: structureType[prop].hide ? structureType[prop].hide : false,
            defaultValue: structureType[prop].defaultValue
              ? structureType[prop].defaultValue
              : structureType[prop].min
              ? structureType[prop].min
              : 0,
            expressionProperties: structureType[prop].expressionProperties
              ? structureType[prop].expressionProperties
              : "",
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              label: "properties.detail.documentArchive.fields." + prop,
              placeholder: "properties.detail.documentArchive.fields." + prop,
              required: structureType[prop].required,
              type: "number",
              step: 1,
              min: structureType[prop].min ? structureType[prop].min : 0,
              max: structureType[prop].max ? structureType[prop].max : 99999,
              disabled: disabled,
            },
          });
        }
        if (structureType[prop].type === "Select") {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "select",
            key: `${prop}`,
            expressionProperties: structureType[prop].expressionProperties
              ? structureType[prop].expressionProperties
              : "",
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              label: "properties.detail.documentArchive.fields." + prop,
              placeholder: "properties.detail.documentArchive.fields." + prop,
              required: structureType[prop].required,
              disabled: disabled,
              options: structureType[prop].options,
            },
          });
        }
        if (structureType[prop].type === "Hidden") {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            key: `${prop}`,
            defaultValue: structureType[prop].defaultValue
              ? structureType[prop].defaultValue
              : "",
          });
        }
        if (structureType[prop].type === "SelectNew") {
          aryFields.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "selectNew",
            key: `${prop}`,
            expressionProperties: structureType[prop].expressionProperties
              ? structureType[prop].expressionProperties
              : "",
            templateOptions: {
              readonly: structureType[prop].readonly
                ? structureType[prop].readonly
                : false,
              customLabel: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              placeholder: structureType[prop].label
                ? `properties.detail.documentArchive.fields.${structureType[prop].label}`
                : `properties.detail.documentArchive.fields.${prop}`,
              required: structureType[prop].required,
              disabled: disabled,
              // bindLabel: structureType[prop].bindLabel,
              // bindValue: structureType[prop].bindValue,
              multiple: structureType[prop].multiple
                ? structureType[prop].multiple
                : false,
              // search$: structureType[prop].search,
              initialValues: structureType[prop].options,
              addTag: (term: string) => {
                return term.replace(/\./gi, "").toUpperCase();
              },
              addTagText: "common.words.addTag",
            },
          });
        }
      }
      return aryFields;
    }
    return "";
  }

  /**
   * Get document route by doc type
   * docType: es. AC2
   *
   * @since 1.0.0
   */
  getDocRoute2(key: string, documentTemplate: any[]): any {
    let route = "";
    let found = false;
    if (documentTemplate && Array.isArray(documentTemplate)) {
      for (const docs of documentTemplate) {
        const content = docs.content;
        if (content && Array.isArray(content)) {
          for (const subDocs of content) {
            const documents = subDocs.documents;
            if (documents && Array.isArray(documents)) {
              for (const doc of documents) {
                if (doc.key && doc.key === key ) {
                  route = subDocs.title.replace("properties.documents.", "");
                  found = true;
                  break;
                }
              }
            }
            if (found) {
              break;
            }
          }
        }
        if (found) {
          break;
        }
      }
    }
    return route;
  }

  /**
   * Get area from child code (es: properties.structures.gestAmmTivoGestionali, ...)
   */
  getAreaFromChild2(child: string, documentTemplate: any[]): number {
    let code = 0;
    let group = "";
    let found = false;
    if (documentTemplate && Array.isArray(documentTemplate)) {
      for (const docs of documentTemplate) {
        const content = docs.content;
        if (content && Array.isArray(content)) {
          for (const subDocs of content) {
            if (subDocs.title === child) {
              group = docs.group;
              found = true;
              break;
            }
          }
        }
        if (found) {
          break;
        }
      }
    }
    switch(group) {
      case "amministrativo": code = 1; break;
      case "contratti": code = 2; break;
      case "tecnico": code = 3; break;
      case "unitaImmobiliari": code = 4; break;
    }

    return code;
  }

  /**
   * Get topics of docs area from code (es: 1, 2...)
   */
  getDocumentArea2(code: string, documentTemplate: any[]): any {
    if (typeof code === "undefined" || code === undefined) {
      return {};
    }
    let codeArea = "";
    switch(code) {
      case "1": codeArea = "amministrativo"; break;
      case "2": codeArea = "contratti"; break;
      case "3": codeArea = "tecnico"; break;
      case "4": codeArea = "unitaImmobiliari"; break;
    }

    const subArea = documentTemplate.filter((elem: any) => {
      return elem.group === codeArea;
    });
    if (subArea) {
      return {
        code,
        content: subArea,
        title: codeArea,
      };
    } else {
      return {};
    }
  }

  /**
   * Get subdocs from subarea
   */
  getSubDocsArea2(subarea: string, documentTemplate: any[], subscriptionFree = false): any {
    let element: any;
    let found = false;
    let contratti = false;
    for (const item of documentTemplate) {
    // documentTemplate.forEach((item: any) => {
      if (
        item.title == `properties.documents.${subarea}` && 
        subarea !== 'stackingPlan' && 
        subarea !== 'reportistica' && 
        subarea !== 'locazioneContrdiLocazione' &&
        subarea !== 'lineaVita' &&
        subarea !== 'amiantoDoc' &&
        subarea !== 'impiantiSpeciali'
      ) {
        if (subarea === "contratti" && item.content && Array.isArray(item.content)) {
          contratti = true;
          item.content.forEach((subItem: any) => {
            if (subItem.title == `properties.documents.${subarea}`) {
              
              if (subItem.documents && Array.isArray(subItem.documents)) {
                for (const subDoc of subItem.documents) {
                  subDoc.visible = true;
                  subDoc.value = false;
                  if (subDoc.key === "HA12") {
                    subDoc.origin = "impelegenerale-contratti";
                    subDoc.structure = "fornituraBt";
                  } else if (subDoc.key === "HA64") {
                    subDoc.origin = "impeleMediaTensione-contratti";
                    subDoc.structure = "fornituraMt";
                  }
                }
              }
              
              element = subItem;
            }
          });
          break;
        } else if (subarea === "unitaImmobiliari" && item.content && Array.isArray(item.content)) {
          let docs = [];
          let title = {};
          item.content.forEach((subItem: any) => {
            const parentTitle = subItem.title.replace("properties.documents.", "");
            if (subItem.documents && Array.isArray(subItem.documents)) {
              subItem.documents.forEach((elDocs: any) => elDocs.parentTitle = parentTitle)
            }
            title = subItem.translation;
            docs = [...docs, title, ...subItem.documents];
          });
          element = item;
          element.documents = docs;
        } else {
          element = item;
          break;
        }
      } else if (item.content && Array.isArray(item.content)) {
        item.content.forEach((subItem: any) => {
          if (subItem.title == `properties.documents.${subarea}`) {
            element = subItem;
            found = true;
          }
        });
        if (found) {
          break;
        }
      }
    }

    if (contratti) {
      const contracts: any[] = [];
      let structure = "";
      // Add contracts from other document types
      for (const docs of documentTemplate) {
        if (
          docs.content && 
          Array.isArray(docs.content) && 
          docs.code !== "H" &&
          !(subscriptionFree && docs.code === "U")
        ) {
          for (const subDocs of docs.content) {
            const documents = subDocs.documents;
            if (subDocs.structure !== "") {
              structure = subDocs.structure;
            } else {
              structure = "";
            }

            const origin = subDocs.title.replace("properties.documents.", "");
            
            if (documents && Array.isArray(documents)) {
              for (const doc of documents) {
                if (doc.contract) {
                  contracts.push({
                    _id: doc._id,
                    contract: doc.contract,
                    deleted: doc.deleted,
                    expirationNotice: doc.expirationNotice,
                    key: doc.key,
                    mandatory: doc.mandatory,
                    schemaType: doc.schemaType,
                    translation: doc.translation,
                    origin,
                    structure,
                    value: false,
                    visible: true,
                  })
                }
              }
            }
          }
        }
      }

      if (element.documents && Array.isArray(element.documents) && contracts && Array.isArray(contracts)) {
        contracts.forEach((elConttract: any) => {
          element.documents.push({
            _id: elConttract._id,
            contract: elConttract.contract,
            deleted: elConttract.deleted,
            expirationNotice: elConttract.expirationNotice,
            key: elConttract.key,
            mandatory: elConttract.mandatory,
            schemaType: elConttract.schemaType,
            translation: elConttract.translation,
            origin: elConttract.origin,
            structure: elConttract.structure,
            value: elConttract.value,
            visible: elConttract.visible,
          });
        });
        if (this.orderContracts && Array.isArray(this.orderContracts)) {
          this.orderContracts.forEach((orderEl: string, orderIndex: number) => {
            const fromIndex = element.documents.findIndex((el: any) => {
              return el.key === orderEl;
            });
            if (fromIndex > -1) {
              const contractElement = element.documents[fromIndex];
              element.documents.splice(fromIndex, 1);
              element.documents.splice(orderIndex, 0, contractElement);
            }
          });
        }
      }
      // End - Add contracts from other document types
    }
    return element;
  }

  /**
   * Get type of doc from code
   */
  getDocumentType2(code: string, documentTemplate: any[]): string {
    let schemaType = "";
    let found = false;
    if (documentTemplate && Array.isArray(documentTemplate)) {
      for (const docs of documentTemplate) {
        const content = docs.content;
        if (content && Array.isArray(content)) {
          for (const subDocs of content) {
            const documents = subDocs.documents;
            if (documents && Array.isArray(documents)) {
              for (const doc of documents) {
                if (doc.key && doc.key === code ) {
                  schemaType = doc.schemaType;
                  found = true;
                  break;
                }
              }
            }
            if (found) {
              break;
            }
          }
        }
        if (found) {
          break;
        }
      }
    }
    return schemaType;
  }

  /**
   * Get topics of docs area from code (es: A, B...)
   */
  getDocumentTopic2(code: string, documentTemplate: any[], structure?: any): any[] {
    let topic;
    const structureSubCodeToFilter: string[] = [];

    if (documentTemplate) {
      topic = documentTemplate.filter((arg) => arg.code === code)[0];
      if (structure) {
        if (topic.content && Array.isArray(topic.content)) {
          topic.content.forEach((el: any) => {
            if (el.structure && el.structure !== "" ) {
              if (
                !structure[el.structure].length ||
                (structure[el.structure].length &&
                  !structure[el.structure].some((prop: any) => prop.active))
              ) {
                if (el.code === "AA") { // Gestionale Dipendenti
                  structureSubCodeToFilter.push("AB");
                }
                structureSubCodeToFilter.push(el.code);
              }
            }
            if (el.code === "IA") {
              // Impianto elettrico generale
              if (
                !structure["fornituraBt"].length ||
                (structure["fornituraBt"].length &&
                  !structure["fornituraBt"].some((prop: any) => prop.active))
              ) {
                structureSubCodeToFilter.push(el.code);
              }
            }
            if (el.code === "IB") {
              // Impanto elettrico di Media Tensione
              if (
                !structure["fornituraMt"].length ||
                (structure["fornituraMt"].length &&
                  !structure["fornituraMt"].some((prop: any) => prop.active))
              ) {
                structureSubCodeToFilter.push(el.code);
              }
            }
            if (el.code === "QG") {
              // Impanto EVAC
              if (
                !structure["evac"].length ||
                (structure["evac"].length &&
                  !structure["evac"].some((prop: any) => prop.active))
              ) {
                structureSubCodeToFilter.push(el.code);
              }
            }
          });
        }
      }
    }

    const content = [];

    topic.content.forEach((element: any) => {
      const title: string = element.title;
      const rawTitle = title.split(".documents.", 2)[1];

      // A section hidden from the settings ("nascosto") is offered neither for new
      // documents nor as a search filter, as already happens for its documents.
      if (element.deleted !== true && !structureSubCodeToFilter.includes(element.code.toString())) {
        content.push({
          type: "doc",
          class: "doc",
          visible: true,
          code: element.code,
          title,
          translation: element.translation,
          rawTitle,
          parent: topic.code,
          value: false,
        });
      }
    });
    return content;
  }

  /**
   * Get topics of docs area from key (es: AA, AB...)
   */
  getDocumentSubTopic2(code: string, parent: string, documentTemplate: any[], structure: any, subscriptionFree = false, lang = "it"): any[] {
    const content = [];
    let subAreaTitle = "";

    if (documentTemplate) {
      const topic = documentTemplate.filter((arg) => arg.code === parent)[0];
      const subTopic = topic.content.find((el: any) => {
        return el.code === code;
      });

      if (subTopic && subTopic.translation) {
        subAreaTitle = subTopic.translation[lang];
      }

      // Contratti
      if (code === "HA" && parent == "H") {
        
        subTopic.documents.forEach((element: any) => {
          const title: string = element.translation.it;
          const rawTitle = title.split(".documents.", 2)[1];

          let origin = element.origin ? element.origin : "";
          let loadDoc = true;
          // Impianto elettrico generale
          if (element.key === "HA12") {
            origin = "impelegenerale-contratti";
            if (structure && 
                (!structure["fornituraBt"].length ||
                (structure["fornituraBt"].length &&
                  !structure["fornituraBt"].some((prop: any) => prop.active)))
            ) {
              loadDoc = false;
            }
          }
          // Impianto elettrico media tensione
          if (element.key === "HA64") {
            origin = "impeleMediaTensione-contratti";
            if (structure && 
                (!structure["fornituraMt"].length ||
                (structure["fornituraMt"].length &&
                  !structure["fornituraMt"].some((prop: any) => prop.active)))
            ) {
              loadDoc = false;
            }
          }
          if (loadDoc) {
            content.push({
              origin,
              type: "doc",
              class: "doc",
              visible: true,
              code: element.key,
              title: element.translation.it,
              translation: element.translation,
              rawTitle,
              parent: subTopic.code,
              value: false,
              schemaType: element.schemaType,
              deleted: element.deleted,
              subAreaTitle,
              mandatory: element.mandatory,
              privacy: element.privacy
            });
          }
        });

        // FREE: hide Unità Immobiliari contracts
        for (const docs of documentTemplate) {
          if (
            docs.code !== "H" &&
            !(subscriptionFree && docs.code === "U")
          ) {
            if (docs.content && Array.isArray(docs.content)) {
              for (const subDocs of docs.content) {
                const origin = subDocs.title.replace("properties.documents.", "");
                const documents = subDocs.documents;
                if (structure && subDocs.structure && subDocs.structure !== "") {
                  if (
                    !structure[subDocs.structure].length ||
                    (structure[subDocs.structure].length &&
                      !structure[subDocs.structure].some((prop: any) => prop.active))
                  ) {
                    continue;
                  }
                }
                if (documents && Array.isArray(documents)) {
                  for (const doc of documents) {
                    if (doc.contract) {
                      if (
                        doc.key && 
                        (
                          (
                            doc.key.substring(0, 2) !== 'IA' && 
                            doc.key.substring(0, 2) !== 'IB'
                          ) ||
                          (
                            doc.key.substring(0, 2) === 'IA' &&
                            (
                              // No property structure (e.g. multi-property search): do not filter
                              !structure ||
                              structure["fornituraBt"] &&
                              structure["fornituraBt"].length &&
                              structure["fornituraBt"].some((prop: any) => prop.active)
                            )
                          ) ||
                          (
                            doc.key.substring(0, 2) === 'IB' &&
                            (
                              // No property structure (e.g. multi-property search): do not filter
                              !structure ||
                              structure["fornituraMt"] &&
                              structure["fornituraMt"].length &&
                              structure["fornituraMt"].some((prop: any) => prop.active)
                            )
                          )
                        )
                      ) {
                        const title: string = doc.translation.it;
                        const rawTitle = title.split(".documents.", 2)[1];
                        content.push({
                          origin: origin ? origin : "",
                          type: "doc",
                          class: "doc",
                          visible: true,
                          code: doc.key,
                          title: doc.translation.it,
                          translation: doc.translation,
                          rawTitle,
                          parent: subTopic.code,
                          value: false,
                          schemaType: doc.schemaType,
                          deleted: doc.deleted,
                          subAreaTitle,
                          mandatory: doc.mandatory,
                          privacy: doc.privacy
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (this.orderContracts && Array.isArray(this.orderContracts)) {
          this.orderContracts.forEach((orderEl: string, orderIndex: number) => {
            const fromIndex = content.findIndex((el: any) => {
              return el.code === orderEl;
            });
            if (fromIndex > -1) {
              const contractElement = content[fromIndex];
              content.splice(fromIndex, 1);
              content.splice(orderIndex, 0, contractElement);
            }
          });
        }
      } else {

        subTopic.documents.forEach((element: any) => {
          const title: string = element.translation.it;
          const rawTitle = title.split(".documents.", 2)[1];
    
          if (!element.deleted) {
            content.push({
              origin: element.origin ? element.origin : "",
              type: "doc",
              class: "doc",
              visible: true,
              code: element.key,
              title: element.translation.it,
              translation: element.translation,
              rawTitle,
              parent: subTopic.code,
              value: false,
              schemaType: element.schemaType,
              deleted: element.deleted,
              subAreaTitle,
              mandatory: element.mandatory,
              privacy: element.privacy
            });
          }
        });
      }
    }

    return content;
  }
  
  isContract2(code: string, documentTemplate: any[]): boolean {
    let contract = false;
    let found = false;
    if (documentTemplate && Array.isArray(documentTemplate)) {
      for (const docs of documentTemplate) {
        const content = docs.content;
        if (content && Array.isArray(content)) {
          for (const subDocs of content) {
            const documents = subDocs.documents;
            if (documents && Array.isArray(documents)) {
              for (const doc of documents) {
                if (doc.key && doc.key === code ) {
                  contract = doc.contract;
                  found = true;
                  break;
                }
              }
            }
            if (found) {
              break;
            }
          }
        }
        if (found) {
          break;
        }
      }
    }
    return contract;
  }

  /**
   * Order docs by expired property
   *
   * @since 1.0.0
   */
  compareExpired(a, b): any {
    if (a.expired < b.expired) {
      return -1;
    } else if (a.expired > b.expired) {
      return 1;
    } else {
      return 0;
    }
  }

  /**
   * Utility: extracts documents from one section of documentArchive
   * and show the documents into page
   * in getDocumentArchiveData()
   *
   * array of documents
   *
   * @since 1.0.0
   */
  getDocsFromSection(
    section: any, 
    lang: string, 
    docsTemplate: any[], 
    subscriptionType: string, 
    insertedDocs: any[],
    structureDocDeleted = false
  ): any {
    const docList = [];
    for (const doc in section.documents) {
      const templateDoc = docsTemplate.find(( el: any) => {
        return el.key === doc;
      })
      if (section.documents[doc].length && templateDoc && !templateDoc.deleted) {
        section.documents[doc].forEach((item: any) => {
          if (!item.deleted || structureDocDeleted) {
            if (
              item.data &&
              item.data.nomeSocietaEroganteInServizio &&
              // (item.data.rilasciatoFirmatoDa ||
              //   item.data.nomeDiRiferimento ||
              //   item.data.nomeSocietaEroganteInServizio ||
              //   item.data.nomeConduttore ||
              //   item.data.ragioneSocialeCostruttore ||
              //   item.data.daNome ||
              //   item.data.riferimentoComuneASL ||
              //   item.data.nomeAmministratoreDelCondominio ||
              //   item.data.nomeIdentificativoDellaReteDiTeleriscaldamento ||
              //   item.data.aFirmaDi ||
              //   item.data.nomeFornitore) &&
              typeof item.data.ragioneSocialeFornitore === "undefined"
            ) {
              if (item.data.rilasciatoFirmatoDa) {
                item.data["ragioneSocialeFornitore"] =
                  item.data.rilasciatoFirmatoDa;
              } else if (item.data.nomeDiRiferimento) {
                item.data["ragioneSocialeFornitore"] =
                  item.data.nomeDiRiferimento;
              } else if (item.data.nomeConduttore) {
                item.data["ragioneSocialeFornitore"] = item.data.nomeConduttore;
              } else if (item.data.ragioneSocialeCostruttore) {
                item.data["ragioneSocialeFornitore"] =
                  item.data.ragioneSocialeCostruttore;
              } else if (item.data.daNome) {
                item.data["ragioneSocialeFornitore"] = item.data.daNome;
              } else if (item.data.riferimentoComuneASL) {
                item.data["ragioneSocialeFornitore"] =
                  item.data.riferimentoComuneASL;
              } else if (item.data.nomeAmministratoreDelCondominio) {
                item.data["ragioneSocialeFornitore"] =
                  item.data.nomeAmministratoreDelCondominio;
              } else if (
                item.data.nomeIdentificativoDellaReteDiTeleriscaldamento
              ) {
                item.data["ragioneSocialeFornitore"] =
                  item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
              } else if (item.data.aFirmaDi) {
                item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
              } else if (item.data.nomeFornitore) {
                item.data["ragioneSocialeFornitore"] = item.data.nomeFornitore;
              } else {
                item.data["ragioneSocialeFornitore"] =
                  item.data.nomeSocietaEroganteInServizio;
              }
            }
            if (item.data && item.data.barCode) {
              if (item.data.barCode.length > 6) {
                const docType = item.data.barCode.slice(-1);
                const docCode = item.data.barCode.substring(
                  item.data.barCode.length - 7,
                  item.data.barCode.length - 1
                );
                item.data["docCode"] = `${docCode} ${docType}`;
              }
            }
            if (item.data && item.cancellationRequestBy) {
              item.data.cancellationRequestBy = item.cancellationRequestBy;
              item.data.cancellationRequestDate = item.cancellationRequestDate;
            }
            docList.push({
              title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
              type: "doc",
              docId: item._id,
              key: doc,
              mandatory: (subscriptionType === "FREE" || subscriptionType === "FREEBASIC") ? false : item.mandatory, // templateDoc.mandatory
              mockup: item.mockup,
              expired: item.expired,
              deleted: item.deleted,
              toHardDelete: item.toHardDelete,
              hardDeleteDate: item.hardDeleteDate,
              dateExpired: item.dateExpired,
              contract: item.contract,
              pdfmsg: item.pdfmsg,
              data: item.data,
              checked: false,
              privacy: item.privacy
            });
          }
          if ((!item.deleted || structureDocDeleted) && item.data) {
            insertedDocs.push({
              title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
              docId: item._id,
              data: item.data,
              checked: false,
            });
          }
        });
      }
    }

    let orderedDocList: any[] = [];
    if (docsTemplate && Array.isArray(docsTemplate)) {
      docsTemplate.forEach((orderEl: any) => {
        const docListFiltered = docList.filter((el: any) => {
          return el.key === orderEl.key;
        });
        orderedDocList = orderedDocList.concat(docListFiltered);
      });
    }

    orderedDocList.sort(this.compareExpired);
    return orderedDocList;
  }

  /**
   * Utility: extracts only contracts from one section of documentArchive
   * and show the documents into page
   * in getDocumentArchiveData()
   *
   * array of documents
   *
   * @since 1.0.0
   */
  getDocsFromContractSection(
    section: any, 
    keyTranslateTitle: any, 
    lang: string, 
    docsTemplate: any[], 
    subscriptionType: string, 
    insertedDocs: any[],
    structureDocDeleted = false
  ): any {
    const docList = [];
    for (const doc in section.documents) {
      if (doc.substring(0, 2) === 'EA' || doc === 'RF4') {
        continue;
      }
      const templateDoc = docsTemplate.find(( el: any) => {
        return el.key === doc;
      })
      if (section.documents[doc].length && templateDoc && !templateDoc.deleted) {
        section.documents[doc].forEach((item: any) => {
          if (item.contract) {
            if (!item.deleted || structureDocDeleted) {
              if (
                item.data &&
                item.data.nomeSocietaEroganteInServizio &&
                // (item.data.rilasciatoFirmatoDa ||
                //   item.data.nomeDiRiferimento ||
                //   item.data.nomeSocietaEroganteInServizio ||
                //   item.data.nomeConduttore ||
                //   item.data.ragioneSocialeCostruttore ||
                //   item.data.daNome ||
                //   item.data.riferimentoComuneASL ||
                //   item.data.nomeAmministratoreDelCondominio ||
                //   item.data.nomeIdentificativoDellaReteDiTeleriscaldamento ||
                //   item.data.aFirmaDi ||
                //   item.data.nomeFornitore) &&
                typeof item.data.ragioneSocialeFornitore === "undefined"
              ) {
                if (item.data.rilasciatoFirmatoDa) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.rilasciatoFirmatoDa;
                } else if (item.data.nomeDiRiferimento) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeDiRiferimento;
                } else if (item.data.nomeConduttore) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeConduttore;
                } else if (item.data.ragioneSocialeCostruttore) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.ragioneSocialeCostruttore;
                } else if (item.data.daNome) {
                  item.data["ragioneSocialeFornitore"] = item.data.daNome;
                } else if (item.data.riferimentoComuneASL) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.riferimentoComuneASL;
                } else if (item.data.nomeAmministratoreDelCondominio) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeAmministratoreDelCondominio;
                } else if (
                  item.data.nomeIdentificativoDellaReteDiTeleriscaldamento
                ) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
                } else if (item.data.aFirmaDi) {
                  item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
                } else if (item.data.nomeFornitore) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeFornitore;
                } else {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeSocietaEroganteInServizio;
                }
              }
              if (item.data && item.data.barCode) {
                if (item.data.barCode.length > 6) {
                  const docType = item.data.barCode.slice(-1);
                  const docCode = item.data.barCode.substring(
                    item.data.barCode.length - 7,
                    item.data.barCode.length - 1
                  );
                  item.data["docCode"] = `${docCode} ${docType}`;
                }
              }
              if (item.data && item.cancellationRequestBy) {
                item.data.cancellationRequestBy = item.cancellationRequestBy;
                item.data.cancellationRequestDate = item.cancellationRequestDate;
              }
              docList.push({
                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                type: "doc",
                docId: item._id,
                key: doc,
                mandatory: (subscriptionType === "FREE" || subscriptionType === "FREEBASIC") ? false : item.mandatory,
                mockup: item.mockup,
                expired: item.expired,
                deleted: item.deleted,
                toHardDelete: item.toHardDelete,
                hardDeleteDate: item.hardDeleteDate,
                dateExpired: item.dateExpired,
                contract: item.contract,
                pdfmsg: item.pdfmsg,
                data: item.data,
                checked: false,
                keyTranslateTitle,
                structureObjectId: item.structureObjectId !== "" ? item.structureObjectId : ""
              });
            }
            // only contracts
            const contractSection = doc.substr(0, 2) === "HA" ? true : false;
            if ((!item.deleted || structureDocDeleted) && item.data && contractSection) {
              insertedDocs.push({
                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                docId: item._id,
                data: item.data,
                checked: false,
                keyTranslateTitle,
              });
            }
          }
        });
      }
    }

    docList.sort(this.compareExpired);
    return docList;
  }

  /**
   * Utility: extracts only privacy documents from one section of documentArchive
   * and show the documents into page
   * in getDocumentArchiveData()
   *
   * array of documents
   *
   * isOwnSection identifies documents that live exclusively in the "privacy" area's
   * own section (document.privacy): only those are pushed to insertedDocs here,
   * since documents aggregated from other areas are already pushed by getDocsFromSection()
   * when their origin area is processed, and pushing them again would duplicate entries
   * in the "send by email" attachment picker.
   *
   * @since 1.0.0
   */
  getDocsFromPrivacySection(
    section: any,
    keyTranslateTitle: any,
    lang: string,
    docsTemplate: any[],
    subscriptionType: string,
    insertedDocs: any[],
    structureDocDeleted = false,
    isOwnSection = false
  ): any {
    const docList: any[] = [];
    for (const doc in section.documents) {
      const templateDoc = docsTemplate.find((el: any) => {
        return el.key === doc;
      })
      if (section.documents[doc].length && templateDoc && !templateDoc.deleted) {
        section.documents[doc].forEach((item: any) => {
          if (item.privacy) {
            if (!item.deleted || structureDocDeleted) {
              if (
                item.data &&
                item.data.nomeSocietaEroganteInServizio &&
                typeof item.data.ragioneSocialeFornitore === "undefined"
              ) {
                if (item.data.rilasciatoFirmatoDa) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.rilasciatoFirmatoDa;
                } else if (item.data.nomeDiRiferimento) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeDiRiferimento;
                } else if (item.data.nomeConduttore) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeConduttore;
                } else if (item.data.ragioneSocialeCostruttore) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.ragioneSocialeCostruttore;
                } else if (item.data.daNome) {
                  item.data["ragioneSocialeFornitore"] = item.data.daNome;
                } else if (item.data.riferimentoComuneASL) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.riferimentoComuneASL;
                } else if (item.data.nomeAmministratoreDelCondominio) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeAmministratoreDelCondominio;
                } else if (
                  item.data.nomeIdentificativoDellaReteDiTeleriscaldamento
                ) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
                } else if (item.data.aFirmaDi) {
                  item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
                } else if (item.data.nomeFornitore) {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeFornitore;
                } else {
                  item.data["ragioneSocialeFornitore"] =
                    item.data.nomeSocietaEroganteInServizio;
                }
              }
              if (item.data && item.data.barCode) {
                if (item.data.barCode.length > 6) {
                  const docType = item.data.barCode.slice(-1);
                  const docCode = item.data.barCode.substring(
                    item.data.barCode.length - 7,
                    item.data.barCode.length - 1
                  );
                  item.data["docCode"] = `${docCode} ${docType}`;
                }
              }
              docList.push({
                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                type: "doc",
                docId: item._id,
                key: doc,
                mandatory: (subscriptionType === "FREE" || subscriptionType === "FREEBASIC") ? false : item.mandatory,
                mockup: item.mockup,
                expired: item.expired,
                deleted: item.deleted,
                toHardDelete: item.toHardDelete,
                hardDeleteDate: item.hardDeleteDate,
                dateExpired: item.dateExpired,
                privacy: item.privacy,
                pdfmsg: item.pdfmsg,
                data: item.data,
                checked: false,
                keyTranslateTitle,
                structureObjectId: item.structureObjectId !== "" ? item.structureObjectId : ""
              });
            }
            if (isOwnSection && (!item.deleted || structureDocDeleted) && item.data) {
              insertedDocs.push({
                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                docId: item._id,
                data: item.data,
                checked: false,
                keyTranslateTitle,
              });
            }
          }
        });
      }
    }

    docList.sort(this.compareExpired);
    return docList;
  }

  /**
   * Get documents of current property to show in view
   *
   * @since 1.0.0
   */
  getDocumentArchiveData(
    lang: string,
    documentTemplate: any[],
    condoStructure: any,
    document: any,
    subscriptionType: string,
    insertedDocs: any[],
    structureDocDeleted = false, // Show deleted docs of deleted structures
  ): any[] {
    let gestAmmTivoDipendentiActive = false;
    const allDocs: any[] = [];
    documentTemplate.forEach((area: any) => {
      if (!area.deleted) {
        if (area.title === "properties.documents.unitaImmobiliari") {
          //
          // UNITA' IMMOBILIARI
          // I documenti sono raggruppati per unità immobiliare
          if (
            condoStructure.unitaAbitativaCommerciale &&
            Array.isArray(condoStructure.unitaAbitativaCommerciale) &&
            condoStructure.unitaAbitativaCommerciale.length
          ) {
            const unitaImmobiliari = [];

            condoStructure.unitaAbitativaCommerciale.forEach((el: any) => {
              const contents = [];
              
              if (area.content && Array.isArray(area.content)) {
                area.content.forEach((uiEl: any) => {
                  const title = uiEl.title.replace("properties.documents.", "");
                  if (typeof document[title] !== "undefined" && document[title].length) {
                    const index = document[title].findIndex((item: any) => {
                      return el._id.toString() === item.structureObjectId.toString();
                    });
                    if (index > -1) {
                      const elem = document[title][index];
                      contents.push({
                        title: lang === "it" ? uiEl.translation.it: uiEl.translation.en,
                        active: true,
                        keyTranslateTitle: uiEl.title,
                        type: "title",
                        docId: elem._id,
                        structureId: elem.structureObjectId,
                        content: this.getDocsFromSection(
                          elem, 
                          lang, 
                          uiEl.documents, 
                          subscriptionType, 
                          insertedDocs,
                          (structureDocDeleted && !el.active) // Show deleted docs of deleted structures
                          ),
                      });
                    }
                  }
                });
              }
              unitaImmobiliari.push({
                active: el.active,
                title: el.nome,
                type: "title",
                content: contents,
                keyTranslateTitle: "properties.documents.unitaImmobiliari",
              });
            });

            allDocs.push({
              keyTranslateTitle: "properties.documents.unitaImmobiliari",
              title: lang === "it" ? area.translation.it : area.translation.en,
              type: "title",
              content: unitaImmobiliari,
            });
          }
        } else if (area.title === "properties.documents.contratti") {
          //
          // CONTRATTI
          //
          const contents = [];
          const itemsContract = [];
          itemsContract.push({
            title: "",
            active: true,
            type: "title",
            docId: "",
            structureId: "",
            content: [],
          });

          if (typeof document.contratti !== "undefined" && document.contratti.documents) {
            // document.contratti.forEach((elem: any) => {
              let subDocs = [];
              const active = true;
              let title = "";
              let structureId = 'undefined';
              // if (elem.structureObjectId === "-1") {
                //contratti generici
                subDocs = this.getDocsFromContractSection(
                  document.contratti,
                  "properties.documents.contratti",
                  lang, 
                  area.content[0].documents, 
                  subscriptionType, 
                  insertedDocs
                );
              subDocs.forEach((subElem: any) => {
                title = "";
                structureId = 'undefined';
                if (subElem.key === "HA12") {
                  // Contratto fornitura energia elettrica bassa tensione
                  if (typeof subElem.structureObjectId !== "undefined") {
                    const structure = condoStructure["fornituraBt"]
                    ? condoStructure["fornituraBt"].find(
                        (item: any) => {
                          return item._id.toString() === subElem.structureObjectId.toString();
                        }
                      )
                    : undefined;
                    if (structure) {
                      // title = structure.nome;
                      title = structure.codicePod;
                      structureId = subElem.structureObjectId;
                    }
                  }
                }
                if (subElem.key === "HA64") {
                  // Contratto fornitura energia elettrica bassa tensione
                  if (typeof subElem.structureObjectId !== "undefined") {
                    const structure = condoStructure["fornituraMt"]
                    ? condoStructure["fornituraMt"].find(
                        (item: any) => {
                          return item._id.toString() === subElem.structureObjectId.toString();
                        }
                      )
                    : undefined;
                    if (structure) {
                      // title = structure.nome;
                      title = structure.numeroContrattofornitur;
                      structureId = subElem.structureObjectId;
                    }
                  }
                }
                
                const element = {
                  structureTitle: title,
                  structureId, // elem.structureObjectId,
                  active: active,
                  documentId: '', // elem._id,
                  ...subElem,
                };
                itemsContract[0].content.push(element);
              });
            // });
          }

          let subDocs = [];
          let active = true;
          let title = "";
          documentTemplate.forEach((contracts: any) => {
            if (contracts.title !== "properties.documents.contratti") {
              contracts.content.forEach((subContracts: any) => {
                const titleSubContract = subContracts.title.replace("properties.documents.", "");
                if (!subContracts.deleted) {
                  if (subContracts.elementType === "object") {
                    if (typeof document[titleSubContract] !== "undefined") {
                      subDocs = this.getDocsFromContractSection(
                        document[titleSubContract],
                        subContracts.title,
                        lang, 
                        subContracts.documents, 
                        subscriptionType, 
                        insertedDocs
                      );
                      subDocs.forEach((subElem: any) => {
                        const element = {
                          structureTitle: "",
                          structureId: "",
                          active: true,
                          documentId: "",
                          ...subElem,
                        };
                        itemsContract[0].content.push(element);
                      });
                    }

                  } else if (subContracts.elementType === "array") {
                    if (typeof document[titleSubContract] !== "undefined" && document[titleSubContract].length) {
                      document[titleSubContract].forEach((elem: any) => {
                        const structureName = condoStructure[subContracts.structure]
                          ? condoStructure[subContracts.structure].find((item: any) => {
                              return item._id.toString() === elem.structureObjectId.toString();
                            })
                          : undefined;
                        if (structureName) {
                          // if (subContracts.structure === "estintori") {
                          //   title = "Estintori"
                          // } else 
                          if (subContracts.structure === "dipendenti") {
                            title = structureName.nome + " " + structureName.cognome
                          } else {
                            title = structureName.nome;
                          } 
                        } else {
                          title = "";
                        }

                        active = structureName ? structureName.active : false;
                        subDocs = this.getDocsFromContractSection(
                          elem,
                          subContracts.title,
                          lang,
                          subContracts.documents,
                          subscriptionType,
                          insertedDocs,
                          (structureDocDeleted && !active) // Show deleted docs of deleted structures
                        );
                        subDocs.forEach((subElem: any) => {
                          const element = {
                            structureTitle: title,
                            structureId: elem.structureObjectId,
                            active: active,
                            documentId: elem._id,
                            ...subElem,
                          };
                          itemsContract[0].content.push(element);
                        });
                      });

                    }
                  }
                }
              });
            }
          });

          if (itemsContract[0].content.length) {
            itemsContract[0].content.sort(this.compareExpired);
            contents.push({
              title: lang === "it" ? area.translation.it : area.translation.en,
              keyTranslateTitle: "properties.documents.contratti",
              type: "contract",
              content: itemsContract,
            });

            allDocs.push({
              keyTranslateTitle: "properties.documents.contratti",
              title: lang === "it" ? area.translation.it : area.translation.en,
              type: "title",
              content: contents,
            });
          }
        } else if (area.title === "properties.documents.Aprivacy") {
          //
          // PRIVACY
          //
          const contents: any[] = [];
          const itemsPrivacy: any[] = [];
          itemsPrivacy.push({
            title: "",
            active: true,
            type: "title",
            docId: "",
            structureId: "",
            content: [],
          });

          if (typeof document.privacy !== "undefined" && document.privacy.documents) {
            const ownSubDocs = this.getDocsFromPrivacySection(
              document.privacy,
              "properties.documents.Aprivacy",
              lang,
              area.content[0].documents,
              subscriptionType,
              insertedDocs,
              false,
              true
            );
            ownSubDocs.forEach((subElem: any) => {
              const element = {
                structureTitle: "",
                structureId: "undefined",
                active: true,
                documentId: "",
                ...subElem,
              };
              itemsPrivacy[0].content.push(element);
            });
          }

          let privacySubDocs = [];
          let privacyActive = true;
          let privacyTitle = "";
          documentTemplate.forEach((privacyAreas: any) => {
            if (privacyAreas.title !== "properties.documents.Aprivacy") {
              privacyAreas.content.forEach((subPrivacy: any) => {
                const titleSubPrivacy = subPrivacy.title.replace("properties.documents.", "");
                if (!subPrivacy.deleted) {
                  if (subPrivacy.elementType === "object") {
                    if (typeof document[titleSubPrivacy] !== "undefined") {
                      privacySubDocs = this.getDocsFromPrivacySection(
                        document[titleSubPrivacy],
                        subPrivacy.title,
                        lang,
                        subPrivacy.documents,
                        subscriptionType,
                        insertedDocs
                      );
                      privacySubDocs.forEach((subElem: any) => {
                        const element = {
                          structureTitle: "",
                          structureId: "",
                          active: true,
                          documentId: "",
                          ...subElem,
                        };
                        itemsPrivacy[0].content.push(element);
                      });
                    }

                  } else if (subPrivacy.elementType === "array") {
                    if (typeof document[titleSubPrivacy] !== "undefined" && document[titleSubPrivacy].length) {
                      document[titleSubPrivacy].forEach((elem: any) => {
                        const structureName = condoStructure[subPrivacy.structure]
                          ? condoStructure[subPrivacy.structure].find((item: any) => {
                              return item._id.toString() === elem.structureObjectId.toString();
                            })
                          : undefined;
                        if (structureName) {
                          if (subPrivacy.structure === "dipendenti") {
                            privacyTitle = structureName.nome + " " + structureName.cognome
                          } else {
                            privacyTitle = structureName.nome;
                          }
                        } else {
                          privacyTitle = "";
                        }

                        privacyActive = structureName ? structureName.active : false;
                        privacySubDocs = this.getDocsFromPrivacySection(
                          elem,
                          subPrivacy.title,
                          lang,
                          subPrivacy.documents,
                          subscriptionType,
                          insertedDocs,
                          (structureDocDeleted && !privacyActive) // Show deleted docs of deleted structures
                        );
                        privacySubDocs.forEach((subElem: any) => {
                          const element = {
                            structureTitle: privacyTitle,
                            structureId: elem.structureObjectId,
                            active: privacyActive,
                            documentId: elem._id,
                            ...subElem,
                          };
                          itemsPrivacy[0].content.push(element);
                        });
                      });

                    }
                  }
                }
              });
            }
          });

          if (itemsPrivacy[0].content.length) {
            itemsPrivacy[0].content.sort(this.compareExpired);
            contents.push({
              title: lang === "it" ? area.translation.it : area.translation.en,
              keyTranslateTitle: "properties.documents.Aprivacy",
              type: "contract",
              content: itemsPrivacy,
            });

            allDocs.push({
              keyTranslateTitle: "properties.documents.Aprivacy",
              title: lang === "it" ? area.translation.it : area.translation.en,
              type: "title",
              content: contents,
            });
          }
        } else if (
          area.title ===
          "properties.documents.attivitaSottopostePrevenzioneIncendi"
        ) {
          if (
            typeof document.vvFdefinitivo !== "undefined" &&
            document.vvFdefinitivo.length
          ) {
            const vvF = [];
            const contents = [];
            const items = document.vvFdefinitivo.map((elem: any) => {
              if (elem.structureObjectId === "-1") {
                //doc  generici
                return {
                  title: lang === "it" ? `Edificio uso terziario ${elem.structureObjectName}` : `Tertiary use building ${elem.structureObjectName}`,
                  keyTranslateTitle: lang === "it" ? `Edificio uso terziario ${elem.structureObjectName}` : `Tertiary use building ${elem.structureObjectName}`,
                  active: true, //(structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(
                    elem, 
                    lang, 
                    area.content[0].documents, 
                    subscriptionType, 
                    insertedDocs
                  ),
                  structureObjectType: "-1",
                };
              } else {
                const structureName = condoStructure[elem.structureObjectType]
                  ? condoStructure[elem.structureObjectType].find(
                      (item: any) => {
                        return item._id.toString() === elem.structureObjectId.toString();
                      }
                    )
                  : undefined;
                const content = this.getDocsFromSection(
                  elem, 
                  lang, 
                  area.content[0].documents, 
                  subscriptionType, 
                  insertedDocs,
                  (structureDocDeleted && !structureName.active) // Show deleted docs of deleted structures
                );
                if (content.length) {
                  return {
                    title: elem.structureObjectName,
                    keyTranslateTitle: elem.structureObjectName,
                    active: structureName ? structureName.active : false,
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: content,
                    structureObjectType: elem.structureObjectType,
                  };
                } else {
                  return [];
                }
              }
            });
            const itemsOrdered = [];
            // fabbricatoAbitativo 77
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "fabbricatoAbitativo") {
                itemsOrdered.push(elem);
              }
            });
            // compartimentoBox 75
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "compartimentoBox") {
                itemsOrdered.push(elem);
              }
            });
            // centraleTermica 74
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "centraleTermica") {
                itemsOrdered.push(elem);
              }
            });
            // gruppoElettrogeno 49
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "gruppoElettrogeno") {
                itemsOrdered.push(elem);
              }
            });
            // attivitavvf 50
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "attivitavvf") {
                itemsOrdered.push(elem);
              }
            });
            // varie
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "-1") {
                itemsOrdered.push(elem);
              }
            });

            if (itemsOrdered.length) {
              contents.push({
                title: lang === "it" ? area.translation.it : area.translation.en,
                keyTranslateTitle: "properties.documents.vvFdefinitivo",
                type: "title",
                content: itemsOrdered,
              });
            }
            if (contents.length) {
              allDocs.push({
                keyTranslateTitle:
                  "properties.documents.attivitaSottopostePrevenzioneIncendi",
                title: lang === "it" ? area.translation.it : area.translation.en,
                type: "title",
                content: contents,
              });
            }
          }
        } else {
          const contents = [];
          area.content.forEach((subArea: any) => {
            if (!subArea.deleted) {
              const title = subArea.title.replace("properties.documents.", "");

              if (subArea.elementType === "object") {
                if (typeof document[title] !== "undefined") {
                  const items = this.getDocsFromSection(
                    document[title], 
                    lang, 
                    subArea.documents, 
                    subscriptionType, 
                    insertedDocs
                  );
                  if (items && Array.isArray(items) && items.length) {
                    if (title === "gestAmmTivoGestioneDipend") {
                      if (!gestAmmTivoDipendentiActive) {
                        if (items && Array.isArray(items)) {
                          items.forEach((item: any) => {
                            item.mandatory = false;
                          })
                        }
                        contents.push({
                          active: false,
                          title:
                            lang === "it"
                              ? subArea.translation.it
                              : subArea.translation.en,
                          keyTranslateTitle: subArea.title,
                          type: "doc",
                          content: items,
                        });
                      } else {
                        contents.push({
                          active: true,
                          title:
                            lang === "it"
                              ? subArea.translation.it
                              : subArea.translation.en,
                          keyTranslateTitle: subArea.title,
                          type: "doc",
                          content: items,
                        });
                      }
                    } else if (
                      title === "gestAmmTivoCauseLegali" ||
                      title === "edileinterventiSuccessivi" ||
                      title === "DpraticheEdilizie"
                    ) {
                      const items2 = [];
                      items.forEach((elem: any) => {
                        if (typeof elem.data !== "undefined") {
                          const index = items2.findIndex((subElem: any) => {
                            return (
                              subElem.title ===
                              elem.data.nomeArchiviazioneIntervento
                            );
                          });
                          if (index > -1) {
                            items2[index].content.push(elem);
                          } else {
                            items2.push({
                              title: elem.data.nomeArchiviazioneIntervento,
                              active: true,
                              type: "title",
                              docId: undefined,
                              structureId: undefined,
                              content: [elem],
                            });
                          }
                        }
                      });
                      if (items2.length) {
                        contents.push({
                          title:
                            lang === "it"
                              ? subArea.translation.it
                              : subArea.translation.en,
                          keyTranslateTitle: subArea.title,
                          type: "title",
                          content: items2,
                        });
                      }
                    } else if (title === "gestAmmTivoValutFornitori") {
                      const items2 = [];
                      items.forEach((elem: any) => {
                        if (typeof elem.data !== "undefined") {
                          const index = items2.findIndex((subElem: any) => {
                            return subElem.title === elem.data.nomeFornitore;
                          });
                          if (index > -1) {
                            items2[index].content.push(elem);
                          } else {
                            items2.push({
                              title: elem.data.nomeFornitore,
                              active: true,
                              type: "title",
                              docId: undefined,
                              structureId: undefined,
                              content: [elem],
                            });
                          }
                        }
                      });
                      if (items2.length) {
                        contents.push({
                          title:
                            lang === "it"
                              ? subArea.translation.it
                              : subArea.translation.en,
                          keyTranslateTitle: subArea.title,
                          type: "title",
                          content: items2,
                        });
                      }
                    } else if (title === "locazioneContrdiLocazione") {
                      const items2 = [];
                      items.forEach((elem: any) => {
                        if (typeof elem.data !== "undefined") {
                          const index = items2.findIndex((subElem: any) => {
                            return subElem.title === elem.data.nomeConduttore;
                          });
                          if (index > -1) {
                            items2[index].content.push(elem);
                          } else {
                            items2.push({
                              title: elem.data.nomeConduttore,
                              active: true,
                              type: "title",
                              docId: undefined,
                              structureId: undefined,
                              content: [elem],
                            });
                          }
                        } else {
                          items2.push({
                            title: "",
                            active: true,
                            type: "title",
                            docId: undefined,
                            structureId: undefined,
                            content: [elem],
                          });
                        }
                      });
                      if (items2.length) {
                        contents.push({
                          title:
                            lang === "it"
                              ? subArea.translation.it
                              : subArea.translation.en,
                          keyTranslateTitle: subArea.title,
                          type: "title",
                          content: items2,
                        });
                      }
                    } else {
                      contents.push({
                        title:
                          lang === "it"
                            ? subArea.translation.it
                            : subArea.translation.en,
                        keyTranslateTitle: subArea.title,
                        type: "doc",
                        content: items,
                      });
                    }
                  }
                }
              } else if (subArea.elementType === "array") {
                if (typeof document[title] !== "undefined" && document[title].length) {
                  const items = document[title].map((elem: any) => {
                    const structureName = condoStructure[subArea.structure]
                      ? condoStructure[subArea.structure].find((item: any) => {
                          return item._id.toString() === elem.structureObjectId.toString();
                        })
                      : undefined;
                    if (
                      title === "gestAmmTivoDipendenti" &&
                      subArea.structure === "dipendenti"
                    ) {
                      if (structureName && structureName.active) {
                        gestAmmTivoDipendentiActive = true;
                      }
                    }

                    let structureTitle = "";
                    if (structureName) {
                      structureTitle = structureName.nome;
                      // if (subArea.structure === "estintori") {
                      //   structureTitle = "Estintori"
                      // }
                      if (subArea.structure === "dipendenti") {
                        structureTitle = structureName.nome + " " + structureName.cognome
                      }
                    }
                    
                    const items = this.getDocsFromSection(
                      elem, 
                      lang, 
                      subArea.documents, 
                      subscriptionType, 
                      insertedDocs,
                      (structureDocDeleted && !(structureName ? structureName.active : false)) // Show deleted docs of deleted structures
                    );
                    return {
                      title: structureTitle,
                      active: structureName ? structureName.active : false,
                      type: "title",
                      docId: elem._id,
                      structureId: elem.structureObjectId,
                      content: items,
                    };
                  });
                  if (items.length) {
                    contents.push({
                      title:
                        lang === "it"
                          ? subArea.translation.it
                          : subArea.translation.en,
                      keyTranslateTitle: subArea.title,
                      type: "title",
                      content: items,
                    });
                  }
                }
              }
            }
          });

          if (contents.length > 0) {
            allDocs.push({
              keyTranslateTitle: area.title,
              title: area.translation.it,
              type: "title",
              content: contents,
            });
          }
        }
      }
    });

    return allDocs;
  }
  
  /**
   * Get documents of current FREE property to show in view
   *
   * @since 1.0.0
   */
   getDocumentArchiveDataFree(
    lang: string,
    documentTemplate: any[],
    document: any,
    subscriptionType: string,
    insertedDocs: any[],
  ): any[] {
    const gestAmmTivoDipendentiActive = true;
    const allDocs: any[] = [];
    documentTemplate.forEach((area: any) => {
      if (!area.deleted) {
        if (area.title === "properties.documents.contratti") {
          //
          // CONTRATTI
          //
          const contents = [];
          const itemsContract = [];
          itemsContract.push({
            title: "",
            active: true,
            type: "title",
            docId: "",
            structureId: "",
            content: [],
          });

          if (
            typeof document.contratti !== "undefined" && 
            document.contratti.documents
          ) {
              // document.contratti.forEach((elem: any) => {
                let subDocs = [];
                const active = true;
                let title = "";
                // if (elem.structureObjectId === "-1") {
                  //contratti generici
                  subDocs = this.getDocsFromContractSection(
                    document.contratti,
                    "properties.documents.contratti",
                    lang, 
                    area.content[0].documents, 
                    subscriptionType, 
                    insertedDocs
                  );
                  title = "";

                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: '',
                    active: active,
                    documentId: '',
                    ...subElem,
                  };
                  itemsContract[0].content.push(element);
                });
            
          }

          let subDocs = [];
          // let active = true;
          // let title = "";
          documentTemplate.forEach((contracts: any) => {
            if (contracts.title !== "properties.documents.contratti") {
              contracts.content.forEach((subContracts: any) => {
                const titleSubContract = subContracts.title.replace("properties.documents.", "");
                if (!subContracts.deleted) {
                  if (subContracts.elementType === "object" || subContracts.elementType === "array") {
                    if (typeof document[titleSubContract] !== "undefined") {
                      subDocs = this.getDocsFromContractSection(
                        document[titleSubContract],
                        subContracts.title,
                        lang, 
                        subContracts.documents, 
                        subscriptionType, 
                        insertedDocs
                      );
                      subDocs.forEach((subElem: any) => {
                        const element = {
                          structureTitle: "",
                          structureId: "",
                          active: true,
                          documentId: "",
                          ...subElem,
                        };
                        // itemsContract[0].content.push(element);
                      });
                    }

                  }
                }
              });
            }
          });

          if (itemsContract[0].content.length) {

            itemsContract[0].content.sort(this.compareExpired);
            contents.push({
              title: lang === "it" ? area.translation.it : area.translation.en,
              keyTranslateTitle: "properties.documents.contratti",
              type: "contract",
              content: itemsContract,
            });

            allDocs.push({
              keyTranslateTitle: "properties.documents.contratti",
              title: lang === "it" ? area.translation.it : area.translation.en,
              type: "title",
              content: contents,
            });
          }
        } else if (area.title === "properties.documents.Aprivacy") {
          //
          // PRIVACY
          //
          const contents: any[] = [];
          const itemsPrivacy: any[] = [];
          itemsPrivacy.push({
            title: "",
            active: true,
            type: "title",
            docId: "",
            structureId: "",
            content: [],
          });

          if (
            typeof document.privacy !== "undefined" &&
            document.privacy.documents
          ) {
            const ownSubDocs = this.getDocsFromPrivacySection(
              document.privacy,
              "properties.documents.Aprivacy",
              lang,
              area.content[0].documents,
              subscriptionType,
              insertedDocs,
              false,
              true
            );

            ownSubDocs.forEach((subElem: any) => {
              const element = {
                structureTitle: "",
                structureId: '',
                active: true,
                documentId: '',
                ...subElem,
              };
              itemsPrivacy[0].content.push(element);
            });
          }

          let privacySubDocs = [];
          documentTemplate.forEach((privacyAreas: any) => {
            if (privacyAreas.title !== "properties.documents.Aprivacy") {
              privacyAreas.content.forEach((subPrivacy: any) => {
                const titleSubPrivacy = subPrivacy.title.replace("properties.documents.", "");
                if (!subPrivacy.deleted) {
                  if (subPrivacy.elementType === "object" || subPrivacy.elementType === "array") {
                    if (typeof document[titleSubPrivacy] !== "undefined") {
                      privacySubDocs = this.getDocsFromPrivacySection(
                        document[titleSubPrivacy],
                        subPrivacy.title,
                        lang,
                        subPrivacy.documents,
                        subscriptionType,
                        insertedDocs
                      );
                      privacySubDocs.forEach((subElem: any) => {
                        const element = {
                          structureTitle: "",
                          structureId: "",
                          active: true,
                          documentId: "",
                          ...subElem,
                        };
                        // itemsPrivacy[0].content.push(element);
                      });
                    }

                  }
                }
              });
            }
          });

          if (itemsPrivacy[0].content.length) {

            itemsPrivacy[0].content.sort(this.compareExpired);
            contents.push({
              title: lang === "it" ? area.translation.it : area.translation.en,
              keyTranslateTitle: "properties.documents.Aprivacy",
              type: "contract",
              content: itemsPrivacy,
            });

            allDocs.push({
              keyTranslateTitle: "properties.documents.Aprivacy",
              title: lang === "it" ? area.translation.it : area.translation.en,
              type: "title",
              content: contents,
            });
          }
        } else if (
          area.title ===
          "properties.documents.attivitaSottopostePrevenzioneIncendi"
        ) {
          if (
            typeof document.vvFdefinitivo !== "undefined"
          ) {
            const vvF = [];
            const contents = [];
            
            const items = this.getDocsFromSection(
              document['vvFdefinitivo'], 
              lang, 
              area.content[0].documents, 
              subscriptionType, 
              insertedDocs
            );
            const itemsOrdered = [];
            

            items.forEach((elem: any) => {
              itemsOrdered.push(elem);
            });

            if (itemsOrdered.length) {
              contents.push({
                title: lang === "it" ? area.translation.it : area.translation.en,
                keyTranslateTitle: "properties.documents.vvFdefinitivo",
                type: "doc",
                content: itemsOrdered,
              });
            }
            if (contents.length) {
              allDocs.push({
                keyTranslateTitle:
                  "properties.documents.attivitaSottopostePrevenzioneIncendi",
                title: lang === "it" ? area.translation.it : area.translation.en,
                type: "title",
                content: contents,
              });
            }
          }
        } else {
          const contents = [];
          area.content.forEach((subArea: any) => {
            if (!subArea.deleted) {
              const title = subArea.title.replace("properties.documents.", "");
              
                if (typeof document[title] !== "undefined") {
                  const items = this.getDocsFromSection(
                    document[title], 
                    lang, 
                    subArea.documents, 
                    subscriptionType, 
                    insertedDocs
                  );

                  if (title === "gestAmmTivoGestioneDipend") {
                    if (!gestAmmTivoDipendentiActive) {
                      if (items && Array.isArray(items)) {
                        items.forEach((item: any) => {
                          item.mandatory = false;
                        })
                      }
                      contents.push({
                        active: false,
                        title:
                          lang === "it"
                            ? subArea.translation.it
                            : subArea.translation.en,
                        keyTranslateTitle: subArea.title,
                        type: "doc",
                        content: items,
                      });
                    } else {
                      contents.push({
                        active: true,
                        title:
                          lang === "it"
                            ? subArea.translation.it
                            : subArea.translation.en,
                        keyTranslateTitle: subArea.title,
                        type: "doc",
                        content: items,
                      });
                    }
                  } else if (
                    title === "gestAmmTivoCauseLegali" ||
                    title === "edileinterventiSuccessivi" ||
                    title === "DpraticheEdilizie"
                  ) {
                    const items2 = [];
                    items.forEach((elem: any) => {
                      if (typeof elem.data !== "undefined") {
                        const index = items2.findIndex((subElem: any) => {
                          return (
                            subElem.title ===
                            elem.data.nomeArchiviazioneIntervento
                          );
                        });
                        if (index > -1) {
                          items2[index].content.push(elem);
                        } else {
                          items2.push({
                            title: elem.data.nomeArchiviazioneIntervento,
                            active: true,
                            type: "title",
                            docId: undefined,
                            structureId: "",
                            content: [elem],
                          });
                        }
                      }
                    });
                    if (items2.length) {
                      contents.push({
                        title:
                          lang === "it"
                            ? subArea.translation.it
                            : subArea.translation.en,
                        keyTranslateTitle: subArea.title,
                        type: "title",
                        content: items2,
                      });
                    }
                  } else if (title === "gestAmmTivoValutFornitori") {
                    const items2 = [];
                    items.forEach((elem: any) => {
                      if (typeof elem.data !== "undefined") {
                        const index = items2.findIndex((subElem: any) => {
                          return subElem.title === elem.data.nomeFornitore;
                        });
                        if (index > -1) {
                          items2[index].content.push(elem);
                        } else {
                          items2.push({
                            title: elem.data.nomeFornitore,
                            active: true,
                            type: "title",
                            docId: undefined,
                            structureId: "",
                            content: [elem],
                          });
                        }
                      }
                    });
                    if (items2.length) {
                      contents.push({
                        title:
                          lang === "it"
                            ? subArea.translation.it
                            : subArea.translation.en,
                        keyTranslateTitle: subArea.title,
                        type: "title",
                        content: items2,
                      });
                    }
                  } else if (title === "locazioneContrdiLocazione") {
                    const items2 = [];
                    items.forEach((elem: any) => {
                      if (typeof elem.data !== "undefined") {
                        const index = items2.findIndex((subElem: any) => {
                          return subElem.title === elem.data.nomeConduttore;
                        });
                        if (index > -1) {
                          items2[index].content.push(elem);
                        } else {
                          items2.push({
                            title: elem.data.nomeConduttore,
                            active: true,
                            type: "title",
                            docId: undefined,
                            structureId: "",
                            content: [elem],
                          });
                        }
                      }
                    });
                    if (items2.length) {
                      contents.push({
                        title:
                          lang === "it"
                            ? subArea.translation.it
                            : subArea.translation.en,
                        keyTranslateTitle: subArea.title,
                        type: "title",
                        content: items2,
                      });
                    }
                  } else {
                    contents.push({
                      title:
                        lang === "it"
                          ? subArea.translation.it
                          : subArea.translation.en,
                      keyTranslateTitle: subArea.title,
                      type: "doc",
                      content: items,
                    });
                  }
                }
              
            }
          });

          if (contents.length > 0) {
            allDocs.push({
              keyTranslateTitle: area.title,
              title: area.translation.it,
              type: "title",
              content: contents,
            });
          }
        }
      }
    });

    return allDocs;
  }
}
